<div class="client_profile_page" *ngIf="session.user; let user">
  <div class="profile_card_top mt-2 md:mt-[10%]">
    <div class="mt-6">
      <img src="/silone/silone_hi.png" />
    </div>
    <div class="text-2xl md:text-3xl font-bold text-center">{{user.name}}</div>
  </div>

  <div class="profile_card">
    <fa-icon icon="envelope"></fa-icon>

    <div class="mb-4">{{user.email}}</div>

    <fa-icon icon="phone-flip"></fa-icon>
    <div>{{user.mobile}}</div>
    <div *ngIf="!user.mobile">N/A</div>
  </div>

  <div class="profile_card_bottom">
    <div
      class="client_button btn_circle"
      (click)="openQrcode()"
      style="height: 70px; width: 70px; font-size: 30px"
    >
      <fa-icon icon="qrcode"></fa-icon>
    </div>
  </div>
</div>
